import { OnboardingApplication } from "consts/onboarding";
import type { ID } from "types";
import { route } from "util/support";

export const enum WebRouteTypes {
    Root = 'Root',
    Dashboard = 'Dashboard',
    Login = 'Login',
    ChangePassword = 'ChangePassword',
    Transactions = 'Transactions',
    TransactionList = 'TransactionList',
    Merchants = 'Merchants',
    Users = 'Users',
    MerchantPayouts = 'MerchantPayouts',
    Consumers = 'Consumers',
    QueryBuilder = 'QueryBuilder',
    Setup = 'Setup',
    OpenBanking = 'OpenBanking',
    Onboarding = 'Onboarding',
    KYCSettings = 'KYCSettings',
};

export const WebRoutes = {
    [WebRouteTypes.Root]: route(['']),
    [WebRouteTypes.Dashboard]: route(['dashboard']),
    [WebRouteTypes.Login]: {
        Index: route(['login']),
        Verify2FA: route(['login', 'verify-2fa']),
        SendResetLink: route(['login', 'send-reset-link'])
    },
    [WebRouteTypes.ChangePassword]: route(['change-password', ':token']),
    [WebRouteTypes.Transactions]: route(['transactions']),
    [WebRouteTypes.TransactionList]: route(['transactions', 'list']),
    [WebRouteTypes.Merchants]: {
        Index: route(['merchants']),
        List: route(['merchants', 'list']),
        TicketingSystem: {
            Index: route(['merchants', 'ticketing-system']),
            Merchant: (merchantId: ID) =>
                route(['merchants', 'ticketing-system', merchantId])
        }
    },
    [WebRouteTypes.KYCSettings]: {
        Index: route(['kyc-settings']),
        MerchantKYCSettings: {
            Index: route(['kyc-settings', 'merchants'])
        },
        PSPKYCSettings: {
            Index: route(['kyc-settings', 'psp'])
        }
    },
    [WebRouteTypes.MerchantPayouts]: route(['merchants-payouts']),
    [WebRouteTypes.Consumers]: {
        Index: route(['consumers']),
        List: route(['consumers', 'list']),
        Blacklisted: route(['consumers', 'blacklisted']),
        WhiteListed: route(['consumers', 'whitelisted']),
        Active: route(['consumers', 'active']),
        ImportHistory: {
            Index: route(['consumers', 'import-history']),
        }
    },
    [WebRouteTypes.Users]: route(['users']),
    [WebRouteTypes.QueryBuilder]: {
        Index: route(['query-builder']),
        EsTransactions: route(['query-builder', 'es-transactions']),
        EsMerchantPayoutFiles: route(['query-builder', 'es-merchant-payout-files'])
    },
    [WebRouteTypes.Setup]: {
        Index: route(['setup']),
        PaymentMethodSetup: route(['setup', 'payment-method']),
        GeneralSetup: route(['setup', 'general']),
        WhatsAppMessaging: {
            Index: route(['setup', 'whatsapp-messaging']),
            MessageLogs: route(['setup', 'whatsapp-messaging', 'message-logs']),
            PhoneVerifications: route(['setup', 'whatsapp-messaging', 'phone-verifications']),
            FailedPhoneVerifications: route(['setup', 'whatsapp-messaging', 'failed-phone-verifications']),
            MessageSetups: route(['setup', 'whatsapp-messaging', 'message-setups']),
            TemplateSetups: route(['setup', 'whatsapp-messaging', 'template-setups'])
        },
        ShipmentTracking: route(['setup', 'shipment-tracking'])
    },
    [WebRouteTypes.OpenBanking]: {
        Index: route(['open-banking']),
        BankingSDK: route(['open-banking', 'banking-sdk']),
        IbanXS: route(['open-banking', 'iban-xs']),
        BankingSDKRecipients: route(['open-banking', 'banking-sdk-recipients']),
        BankingSDKConnectorsRecipientsPivots: route(['open-banking', 'banking-sdk-connectors-recipients-pivots']),
        IbanXSBanksRecipientsPivots: route(['open-banking', 'iban-xs-banks-recipients-pivots']),
        IbanXSBanksCountriesPivots: route(['open-banking', 'iban-xs-banks-countries-pivots'])
    },
    [WebRouteTypes.Onboarding]: {
        Index: route(['onboarding']),
        Applications: {
            Index: route(['onboarding', 'applications', 'general']),
            ECommerce: route(['onboarding', 'applications', OnboardingApplication.ECommerce]),
            HighRisk: route(['onboarding', 'applications', OnboardingApplication.HighRisk])
        }
    }
};
